export default {
    'name': 'dash',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<rect x=\'4\' y=\'12\' width=\'16\' height=\'2\' fill=\'#FF4171\'/>'
}
